import script from "./AccumulatedStat.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccumulatedStat.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__